import React from 'react';
import { VaultKeTheme } from '../../utils/theme';

const AboutPage: React.FC = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      minHeight: '100vh',
      backgroundColor: VaultKeTheme.colors.background,
      color: VaultKeTheme.colors.text,
    },
    main: {
      paddingTop: '80px',
      paddingBottom: VaultKeTheme.spacing.xxl,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: `0 ${VaultKeTheme.spacing.xl}`,
    },
    hero: {
      textAlign: 'center',
      marginBottom: VaultKeTheme.spacing.xxl,
      padding: VaultKeTheme.spacing.xxl,
      background: `linear-gradient(135deg, ${VaultKeTheme.colors.surface} 0%, ${VaultKeTheme.colors.surfaceVariant} 100%)`,
      borderRadius: VaultKeTheme.borderRadius.xl,
    },
    title: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    subtitle: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      maxWidth: '600px',
      margin: '0 auto',
    },
    content: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: VaultKeTheme.spacing.xxl,
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    section: {
      ...VaultKeTheme.components.card,
    },
    sectionTitle: {
      ...VaultKeTheme.typography.h3,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    text: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      lineHeight: '1.7',
      marginBottom: VaultKeTheme.spacing.lg,
    },
    stats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: VaultKeTheme.spacing.lg,
    },
    stat: {
      textAlign: 'center',
      padding: VaultKeTheme.spacing.lg,
      background: `linear-gradient(135deg, ${VaultKeTheme.colors.surface} 0%, ${VaultKeTheme.colors.surfaceVariant} 100%)`,
      borderRadius: VaultKeTheme.borderRadius.lg,
    },
    statNumber: {
      ...VaultKeTheme.typography.h2,
      color: VaultKeTheme.colors.primary,
      marginBottom: VaultKeTheme.spacing.sm,
    },
    statLabel: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
    },
  };

  return (
    <div style={styles.page}>
      <main style={styles.main}>
        <div style={styles.container}>
          <div style={styles.hero}>
            <h1 style={styles.title}>About VaultKe</h1>
            <p style={styles.subtitle}>
              Empowering community savings groups with modern financial technology
              for secure and intelligent wealth management.
            </p>
          </div>

          <div style={styles.content}>
            <div style={styles.section}>
              <h2 style={styles.sectionTitle}>Our Mission</h2>
              <p style={styles.text}>
                VaultKe was founded with a simple yet powerful vision: to modernize traditional
                community savings groups (chamas) by combining time-honored community values
                with cutting-edge financial technology.
              </p>
              <p style={styles.text}>
                We understand that chamas are more than just financial arrangements—they're
                communities built on trust, shared goals, and mutual support. Our platform
                preserves these essential elements while providing the tools needed for
                modern financial management.
              </p>
            </div>

            <div style={styles.section}>
              <h2 style={styles.sectionTitle}>Our Story</h2>
              <p style={styles.text}>
                Born from the recognition that traditional chamas were using outdated methods
                for financial management, VaultKe emerged as a solution that bridges the gap
                between heritage and innovation.
              </p>
              <p style={styles.text}>
                Our team consists of financial experts, community leaders, and technology
                innovators who share a passion for empowering communities. We've built
                VaultKe to be intuitive, secure, and culturally relevant for African communities.
              </p>
            </div>
          </div>

          <div style={styles.stats}>
            <div style={styles.stat}>
              <div style={styles.statNumber}>10K+</div>
              <div style={styles.statLabel}>Active Chamas</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>$2M+</div>
              <div style={styles.statLabel}>Funds Managed</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>50K+</div>
              <div style={styles.statLabel}>Community Members</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>99.9%</div>
              <div style={styles.statLabel}>Uptime</div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;